import { notification } from '@/v2/components/Notification/notification';

export default function onSuccess(data, variables, context, mutation) {
  const success = mutation?.meta?.notification?.success;

  if (success) {
    let successMessage = success;

    if (typeof success === 'function') {
      successMessage = success(data, variables, context, mutation);
    }

    notification.success({
      message: successMessage,
    });
  }

  return;
}
